import { Component, Input } from '@angular/core';
import { ConfirmationInput } from '../../../confirmation/confirmation.model';
import { ConfirmationModule } from '@/shared/components/confirmation/confirmation.module';
import { BaseComponent } from '@/shared/components/base/base.component';

@Component({
  selector: 'vm-strapi-page',
  templateUrl: './strapi-page.component.html',
  styleUrls: ['./strapi-page.component.scss'],
  standalone: true,
  imports: [ ConfirmationModule ]
})
export class StrapiPageComponent extends BaseComponent {
  @Input() confirmationInput: ConfirmationInput;
}
